<template>
  <GlobusCalendar
    v-model="calendarDates"
    :locale="activeLanguage"
  />
</template>

<script setup>
import { computed } from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { useLK } from "@/controllerLK/LKstore";

const newsFeedStore = useNewsFeedStore();

const LKStore = useLK();
const activeLanguage = computed(() => {
  try {
    return LKStore.user.language.toLowerCase();
  } catch (error) {
    return "ru";
  }
});

const calendarDates = computed({
  get() {
    // из стора (seconds) → в JS Date (ms)
    return [
      new Date(newsFeedStore.dateFrom * 1000),
      new Date(newsFeedStore.dateTo   * 1000)
    ];
  },
  set([ startDate, endDate ]) {
    // из JS Date → в seconds
    if (startDate) {
      newsFeedStore.dateFrom = Math.floor(startDate.getTime() / 1000);
    }

    // Если конечная дата не передана, устанавливаем сегодняшний день.
    if (endDate) {
      newsFeedStore.dateTo   = Math.floor(endDate.getTime() / 1000);
    } else {
      newsFeedStore.dateTo = Math.floor(new Date().getTime() / 1000);
    }

    // обновляем ленту
    newsFeedStore.clearNewsFeed();
    newsFeedStore.getNews();
  }
});
</script>
